<template>
  <div class="nav-bar main-bar flex">
    <div class="navigation">
      <slot name="nav" />
    </div>
  </div>
</template>
